export default __webpack_public_path__ + "static/media/nft_image_5.46156b66.png";